import { render, staticRenderFns } from "./search.component.vue?vue&type=template&id=6f8a842c&scoped=true"
import script from "./search.component.vue?vue&type=script&lang=js"
export * from "./search.component.vue?vue&type=script&lang=js"
import style0 from "./search.component.vue?vue&type=style&index=0&id=6f8a842c&prod&scoped=true&lang=css"
import style1 from "./search.component.vue?vue&type=style&index=1&id=6f8a842c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a842c",
  null
  
)

export default component.exports